export default __webpack_public_path__ + "static/media/sass_reactjs.aabc904a.webp";